import React, {forwardRef} from 'react'
import Link from '../../../link'

/**
 * The app `Link` opted out of the shared link recipe, for use as
 * `header-icon-button`'s `as` target whenever an icon CTA navigates.
 *
 * `HeaderIconButton` renders its `Button` `unstyled`, but Chakra consumes that
 * flag inside `Button`, so an `as` target that is itself recipe-bound still
 * layers its own recipe onto the same DOM node. With the plain app `Link` that
 * put `linkRecipe` (`app/leap/theme/recipes/link.js`) on the round icon chrome,
 * where its more specific rules outranked the chrome's base styles: the
 * `_focusVisible` block turned the ring into a rounded rectangle and collapsed
 * the inline padding from 8px to 2px, resizing the button while it was focused
 * (STOK-17337), and the `& span` rule held the cart's count badge in flow
 * instead of pinned to the icon corner (STOK-17360).
 *
 * `unstyled` leaves the icon chrome as the node's only styling. The anchor
 * needs nothing else from `linkRecipe`: the chrome owns the layout, cursor and
 * icon colour, and Chakra's preflight keeps `a` free of the default underline.
 *
 * @component
 * @returns {JSX.Element}
 */
const HeaderIconLink = forwardRef((props, ref) => <Link ref={ref} unstyled {...props} />)

if (process.env.NODE_ENV !== 'production') {
    HeaderIconLink.displayName = 'HeaderIconLink'
}

export default HeaderIconLink
